<section class="sidebar">
  <app-side-bar
    [sidebarWidth]="sidebarWidth()"
    [isPinned]="isSidebarPinned()"
    [isResizable]="isSidebarResizable"
    (sidebarWidthChange)="onSidebarWidthChange($event)"
    (sidebarAutoCollapsedChange)="onSidebarAutoCollapsedChange($event)"
    (sidebarPinnedChange)="onSidebarPinnedChange($event)"
  ></app-side-bar>
</section>

<header class="header">
  <router-outlet name="header"></router-outlet>
</header>

<main class="main">
  <section class="content" cdkScrollable>
    <router-outlet></router-outlet>
  </section>
</main>

<section class="footer">
  <router-outlet name="footer"></router-outlet>
</section>

<ui-kit-svg-atlas></ui-kit-svg-atlas>
<svg aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;">
  <symbol id="pushpin" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z" fill="currentColor"/>
  </symbol>
  <symbol id="pushpin-fill" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" fill="currentColor"/>
  </symbol>
  <symbol id="comment" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3C1 2.44772 1.44772 2 2 2H22C22.5523 2 23 2.44772 23 3V18C23 18.5523 22.5523 19 22 19H11.7361L6.94721 21.3944C6.63723 21.5494 6.26909 21.5329 5.97427 21.3507C5.67945 21.1684 5.5 20.8466 5.5 20.5V19H2C1.44772 19 1 18.5523 1 18V3ZM3 4V17H6.5C7.05228 17 7.5 17.4477 7.5 18V18.882L11.0528 17.1056C11.1916 17.0361 11.3448 17 11.5 17H21V4H3Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 8.75C7.55228 8.75 8 9.19772 8 9.75V11.25C8 11.8023 7.55228 12.25 7 12.25C6.44772 12.25 6 11.8023 6 11.25V9.75C6 9.19772 6.44772 8.75 7 8.75Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.75C12.5523 8.75 13 9.19772 13 9.75V11.25C13 11.8023 12.5523 12.25 12 12.25C11.4477 12.25 11 11.8023 11 11.25V9.75C11 9.19772 11.4477 8.75 12 8.75Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17 8.75C17.5523 8.75 18 9.19772 18 9.75V11.25C18 11.8023 17.5523 12.25 17 12.25C16.4477 12.25 16 11.8023 16 11.25V9.75C16 9.19772 16.4477 8.75 17 8.75Z" fill="currentColor"/>
  </symbol>
</svg>
